(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FacetValue = /** @class */ (function () {
    function FacetValue(name, count) {
        this.facetValue = name;
        this.facetCount = count;
        this.facetValueSelected = false;
    }
    FacetValue.prototype.setFacetValueSelected = function (selected) {
        this.facetValueSelected = selected;
    };
    return FacetValue;
}());
exports.default = FacetValue;

},{}],2:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var facet_value_1 = require("./facet-value");
var Facet = /** @class */ (function () {
    function Facet(name, facetObj) {
        this._name = name;
        this._values = [];
        var i, j;
        for (i = 0, j = 1; j < facetObj.length; i += 2, j += 2) {
            this._values.push(new facet_value_1.default(facetObj[i], facetObj[j]));
        }
    }
    Facet.prototype.getValues = function () {
        return this._values;
    };
    return Facet;
}());
exports.default = Facet;

},{"./facet-value":1}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResultItem = /** @class */ (function () {
    function ResultItem(resultObj) {
        this.displayName = resultObj.SN_name;
        this.image = resultObj.Image;
        this.description = resultObj.DescriptionLong;
        this.url = resultObj.URL;
        try {
            var vluxObj = JSON.parse(resultObj.Vlux_data);
            if ('object' === typeof vluxObj) {
                if ((vluxObj.Top_features && 0 < vluxObj.Top_features.length) || vluxObj.Delivery_time) {
                    this.vluxData = {
                        topFeatures: vluxObj.Top_features,
                        deliveryTime: vluxObj.Delivery_time
                    };
                }
            }
        }
        catch (e) {
        }
    }
    return ResultItem;
}());
exports.default = ResultItem;

},{}],4:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var facet_1 = require("./facet");
var result_item_1 = require("./result-item");
var tracking_1 = require("./tracking");
var ResultPage = /** @class */ (function () {
    function ResultPage(element, selectors, searchString, searchCustomerContext) {
        // Indicator to check if a search request is active to avoid multiple request
        this._searchRunning = false;
        // Options
        this.ROWS = 5;
        this.START = 0;
        this.NUMFOUND = 0;
        this.INITIALSEARCH = false;
        this.INITIALPAGEVIEW = true;
        this.CONTEXTMATCHING = {
            'private': 'Privatkunden',
            'soho': 'Selbständige',
            'enterprise': 'Unternehmen'
        };
        this.AREAMATCHING = {
            'shop': 'Shop',
            'infos': 'Infos',
            'forum': 'Forum',
            'support': 'Hilfe'
        };
        this.LAZYLOADINGROWS = 5;
        this._element = element;
        this._selectors = selectors;
        this._selectedAreaFacets = [];
        this.bindEvents();
        if (undefined !== searchCustomerContext && '' !== searchCustomerContext) {
            var splittedContextParam = searchCustomerContext.split('|');
            this._selectedCustomerContext = this.CONTEXTMATCHING[splittedContextParam[0]];
            if (splittedContextParam[1] && this.AREAMATCHING[splittedContextParam[1].split('.')[1]]) {
                this._selectedAreaFacets.push(this.AREAMATCHING[splittedContextParam[1].split('.')[1]]);
                window.sessionStorage.setItem('selectedAreaFacetValues', JSON.stringify(this._selectedAreaFacets));
            }
        }
        else {
            if (window.sessionStorage.getItem('selectedCustomerContextFacetValue')) {
                this._selectedCustomerContext = window.sessionStorage.getItem('selectedCustomerContextFacetValue');
            }
            else {
                this._selectedCustomerContext = this.getPageCustomerContext();
            }
        }
        if (window.sessionStorage.getItem('resultsCount')) {
            this.ROWS = parseInt(window.sessionStorage.getItem('resultsCount'));
        }
        if (undefined === searchString || '' === searchString) {
            if (window.sessionStorage.getItem('searchString')) {
                searchString = window.sessionStorage.getItem('searchString');
            }
        }
        if (window.sessionStorage.getItem('selectedAreaFacetValues')) {
            this._selectedAreaFacets = JSON.parse(window.sessionStorage.getItem('selectedAreaFacetValues'));
        }
        if (undefined !== searchString && '' !== searchString) {
            this._element.find('input.search-string').val(searchString);
            this._element.find(this._selectors.searchWrapper).addClass('on-focus');
            this.search(searchString);
        }
        else {
            tracking_1.default.getInstance().trackPageView(this.NUMFOUND, this._searchString, 'serp', this._selectedCustomerContext, this._selectedAreaFacets);
        }
    }
    ResultPage.prototype.getPageCustomerContext = function () {
        var pageCustomerContext = 'Privatkunden';
        if (0 < $('meta[name="facets"]').length) {
            if (0 <= $('meta[name="facets"]').attr('content').indexOf('customertype:private')) {
                pageCustomerContext = 'Privatkunden';
            }
            else if (0 <= $('meta[name="facets"]').attr('content').indexOf('customertype:business')) {
                if (0 <= $('meta[name="facets"]').attr('content').indexOf('businesstype:soho')) {
                    pageCustomerContext = 'Selbständige';
                }
                else if (0 <= $('meta[name="facets"]').attr('content').indexOf('businesstype:enterprise')) {
                    pageCustomerContext = 'Unternehmen';
                }
                else {
                    pageCustomerContext = 'Selbständige';
                }
            }
        }
        return pageCustomerContext;
    };
    ResultPage.prototype.renderResults = function (results) {
        if (0 === results.length) {
            this.renderNoResults();
            return;
        }
        this._element.find(this._selectors.resultWrapper).show();
        for (var i = 0; i < results.length; i++) {
            this._element.find(this._selectors.resultWrapper).append(Handlebars.templates['searchresult'](results[i]));
        }
        this._lastResultElementOffsetTop = this._element.find(this._selectors.resultWrapper + ' .serp-result:last-child').offset().top;
        this._lastResultElementHeight = this._element.find(this._selectors.resultWrapper + ' .serp-result:last-child').outerHeight();
    };
    ResultPage.prototype.renderNoResults = function () {
        this._element.find(this._selectors.facetCustomerType).html('');
        this._element.find(this._selectors.facetArea).html('');
        this._element.find(this._selectors.resultWrapper).html('');
        this._element.find(this._selectors.resultWrapper).hide();
        this._element.find(this._selectors.headline + ' .search-count').html('');
        if (0 < this._selectedAreaFacets.length) {
            this._element.find(this._selectors.clearFacetInfo).show();
        }
        else {
            this._element.find(this._selectors.noResultInfo).show();
        }
    };
    ResultPage.prototype.renderAreaFacet = function (facet) {
        this._element.find(this._selectors.facetArea).html('');
        var facetValues = facet.getValues();
        if (0 === facetValues.length) {
            return;
        }
        var i, j;
        for (var i_1 = 0; i_1 < facetValues.length; i_1++) {
            if (0 <= this._selectedAreaFacets.indexOf(facetValues[i_1].facetValue)) {
                // If a selecetd area facet has 0 results, deselect and search again
                if (0 === facetValues[i_1].facetCount) {
                    this._selectedAreaFacets.splice(this._selectedAreaFacets.indexOf(facetValues[i_1].facetValue), 1);
                }
                else {
                    facetValues[i_1].setFacetValueSelected(true);
                }
            }
            this._element.find(this._selectors.facetArea).append(Handlebars.templates['area-facet'](facetValues[i_1]));
        }
        if (0 < this._selectedAreaFacets.length) {
            var sumResults = 0;
            for (var i_2 = 0; i_2 < this._selectedAreaFacets.length; i_2++) {
                sumResults += parseInt(this._element.find('.serp-area-facets .checkBox[data-facet-value="' + this._selectedAreaFacets[i_2] + '"]').data('facet-count'));
            }
            if (isNaN(sumResults)) {
                sumResults = this.NUMFOUND;
            }
            this._element.find(this._selectors.headline + ' .search-count').html('(' + sumResults + ')');
        }
    };
    ResultPage.prototype.renderCustomerContextFacet = function (customerTypeFacet) {
        this._element.find(this._selectors.facetCustomerType).html('');
        var facetValues = customerTypeFacet.getValues();
        if (0 === facetValues.length) {
            return;
        }
        for (var i = 0; i < facetValues.length; i++) {
            if (facetValues[i].facetValue === this._selectedCustomerContext) {
                facetValues[i].setFacetValueSelected(true);
                if (0 === this._selectedAreaFacets.length) {
                    this._element.find(this._selectors.headline + ' .search-count').html('(' + facetValues[i].facetCount + ')');
                }
            }
            this._element.find(this._selectors.facetCustomerType).append(Handlebars.templates['customer-context-facet'](facetValues[i]));
        }
    };
    ResultPage.prototype.replaceState = function (searchString, customerType) {
        var _this = this;
        var query = window.location.search.substring(1);
        var getParams = query.split('&');
        getParams.forEach(function (indexParam, i) {
            var indexPair = indexParam.split('=');
            var paramKey = indexPair[0];
            var paramValue = indexPair[1];
            if ('q' === paramKey || 'question' === paramKey) {
                paramValue = searchString;
                getParams[i] = paramKey + '=' + paramValue;
            }
            if (undefined !== customerType) {
                if ('searchCustomerContext' === paramKey) {
                    for (var index in _this.CONTEXTMATCHING) {
                        if (customerType === _this.CONTEXTMATCHING[index]) {
                            paramValue = index;
                            break;
                        }
                    }
                    getParams[i] = paramKey + '=' + paramValue;
                }
            }
        });
        var stateObj = { info: 'Change URL query' };
        history.replaceState(stateObj, 'new search query', window.location.pathname + '?' + getParams.join('&'));
    };
    ResultPage.prototype.bindEvents = function () {
        var _this = this;
        // Changed JQueryEventObject to JQuery.EventBase
        this._element.find(this._selectors.searchForm).submit(function (event) {
            event.preventDefault();
            _this.INITIALPAGEVIEW = true;
            _this._selectedCustomerContext = _this.getPageCustomerContext();
            _this._selectedAreaFacets = [];
            window.sessionStorage.removeItem('selectedAreaFacetValues');
            var searchString = $(event.currentTarget).find('.search-string').val().toString().replace(/<|>|\(|\)|;/g, '');
            _this.replaceState(searchString, _this._selectedCustomerContext);
            if (!_this._searchRunning && '' !== searchString) {
                _this.clear();
                _this.search(searchString);
            }
        });
        this._element.find(this._selectors.searchForm).on('keyup change paste', '.search-string', function (event) {
            if ('' === $(event.currentTarget).val()) {
                _this._element.find(_this._selectors.searchWrapper).removeClass('on-focus');
            }
            else {
                _this._element.find(_this._selectors.searchWrapper).addClass('on-focus');
            }
        });
        this._element.find(this._selectors.searchForm).on('click', 'button[type="reset"]', function (event) {
            _this._element.find(_this._selectors.searchWrapper).removeClass('on-focus');
        });
        // Bind scroll event for lazy loading
        $(window).on('scroll', function (event) {
            // Get the window height and scroll position to calculate the lazy loading trigger
            var windowHeight = $(event.currentTarget).height();
            var scrollTop = $(event.currentTarget).scrollTop();
            // Trigger search when last result is visible in the viewport
            if (!_this._searchRunning && (windowHeight + scrollTop > (_this._lastResultElementOffsetTop + _this._lastResultElementHeight + 50))) {
                window.sessionStorage.removeItem('resultsCount');
                _this.search(_this._searchString);
            }
        });
        this._element.find(this._selectors.facetArea).on('click', '.checkBox', function (event) {
            if ($(event.currentTarget).hasClass('disabled')) {
                return;
            }
            $(event.currentTarget).toggleClass('selected');
            var facetValue = $(event.currentTarget).data('facet-value');
            if ('' !== facetValue && -1 === _this._selectedAreaFacets.indexOf(facetValue)) {
                _this._selectedAreaFacets.push(facetValue);
                _this.CI = 'ecs_dyn_facet.Bereich=1:' + facetValue;
                tracking_1.default.getInstance().trackFilter(_this._selectedCustomerContext, _this._selectedAreaFacets, 'bereich', facetValue, 'add');
            }
            else if ('' !== facetValue && 0 <= _this._selectedAreaFacets.indexOf(facetValue)) {
                _this._selectedAreaFacets.splice(_this._selectedAreaFacets.indexOf(facetValue), 1);
                _this.CI = 'ecs_dyn_facet.Bereich=0:' + facetValue;
                tracking_1.default.getInstance().trackFilter(_this._selectedCustomerContext, _this._selectedAreaFacets, 'bereich', facetValue, 'remove');
            }
            window.sessionStorage.setItem('selectedAreaFacetValues', JSON.stringify(_this._selectedAreaFacets));
            _this.clear();
            _this.search(_this._searchString);
        });
        this._element.find(this._selectors.facetCustomerType).on('click', 'a', function (event) {
            event.preventDefault();
            if ($(event.currentTarget).hasClass('selected')) {
                return;
            }
            var oldFacetValue = $(_this._selectors.facetCustomerType + ' .selected').data('facet-value');
            $(event.currentTarget).siblings('.selected').removeClass('selected');
            $(event.currentTarget).addClass('selected');
            var facetValue = $(event.currentTarget).data('facet-value');
            _this.replaceState(_this._searchString, facetValue);
            _this.CI = 'ecs_dyn_facet.Kundenart=1:' + facetValue;
            _this._selectedCustomerContext = facetValue;
            window.sessionStorage.setItem('selectedCustomerContextFacetValue', _this._selectedCustomerContext);
            tracking_1.default.getInstance().trackFilter(_this._selectedCustomerContext, _this._selectedAreaFacets, 'kundenart', oldFacetValue, 'remove');
            tracking_1.default.getInstance().trackFilter(_this._selectedCustomerContext, _this._selectedAreaFacets, 'kundenart', facetValue, 'add');
            _this.clear();
            _this.search(_this._searchString);
        });
        this._element.find(this._selectors.clearFacetInfo).on('click', '.clear-filter', function (event) {
            _this._selectedAreaFacets = [];
            window.sessionStorage.removeItem('selectedAreaFacetValues');
            _this._element.find(_this._selectors.clearFacetInfo).hide();
            _this.clear();
            _this.search(_this._searchString);
        });
    };
    ResultPage.prototype.clear = function () {
        this._element.find(this._selectors.resultWrapper).html('');
        this._element.find(this._selectors.resultWrapper).hide();
        this.INITIALSEARCH = false;
        this.NUMFOUND = 0;
        this.START = 0;
        window.sessionStorage.removeItem('resultsCount');
    };
    ResultPage.prototype.search = function (searchString, callback) {
        var _this = this;
        // When all results are displayed search doesn't need to trigger again
        if (this.INITIALSEARCH && (this.START >= this.NUMFOUND)) {
            return;
        }
        this._element.find(this._selectors.headline + ' .search-string').html(searchString);
        this._element.find(this._selectors.noResultInfo).hide();
        this._element.find(this._selectors.clearFacetInfo).hide();
        this._element.find('.spinnerBox').show();
        this._searchRunning = true;
        this._searchString = searchString;
        window.sessionStorage.setItem('searchString', searchString);
        // Prepare the params for the search request
        if (window.sessionStorage.getItem('resultsCount')) {
            this.ROWS = parseInt(window.sessionStorage.getItem('resultsCount'));
        }
        var searchParams = 'sv=search&q=' + encodeURIComponent(searchString) + '&wt=json&rows=' + this.ROWS + '&start=' + this.START;
        if ('' !== this._selectedCustomerContext) {
            searchParams += '&fq=' + encodeURIComponent('ecs_dyn_facet.Kundenart:' + this._selectedCustomerContext);
        }
        if (0 < this._selectedAreaFacets.length) {
            searchParams += '&fq=' + encodeURIComponent('ecs_dyn_facet.Bereich:' + this._selectedAreaFacets.join(','));
        }
        if (this.CI && '' !== this.CI) {
            searchParams += '&ci=' + encodeURIComponent(this.CI);
        }
        // Asynchronous call to get results
        $.ajax({
            url: '/api/search/SearchBridge/search?' + searchParams,
            headers: {
                'Accept': 'application/json'
            },
            method: 'get',
            dataType: 'json'
        }).done(function (response) {
            _this._element.find('.spinnerBox').hide();
            var results = [];
            if (response.response && response.response.docs) {
                for (var i = 0; i < response.response.docs.length; i++) {
                    results.push(new result_item_1.default(response.response.docs[i]));
                }
                // Render the results
                _this.renderResults(results);
                _this._searchRunning = false;
                if (!_this.INITIALSEARCH) {
                    _this.INITIALSEARCH = true;
                }
                _this.NUMFOUND = response.response.numFound;
                _this.START += _this.ROWS;
                window.sessionStorage.setItem('resultsCount', '' + _this.START);
                _this.ROWS = _this.LAZYLOADINGROWS;
                if (_this.INITIALPAGEVIEW) {
                    _this.INITIALPAGEVIEW = false;
                    tracking_1.default.getInstance().trackPageView(_this.NUMFOUND, _this._searchString, 'serp', _this._selectedCustomerContext, _this._selectedAreaFacets);
                }
            }
            if (response.facet_counts && response.facet_counts.facet_fields) {
                var areaFacet = new facet_1.default('Bereich', response.facet_counts.facet_fields['ecs_dyn_facet.Bereich']);
                _this.renderAreaFacet(areaFacet);
                var customerTypeFacet = new facet_1.default('Kundenart', response.facet_counts.facet_fields['ecs_dyn_facet.Kundenart']);
                _this.renderCustomerContextFacet(customerTypeFacet);
            }
        }).fail(function () {
            _this._searchRunning = false;
            _this._element.find('.spinnerBox').hide();
            _this.renderNoResults();
        });
    };
    return ResultPage;
}());
exports.default = ResultPage;

},{"./facet":2,"./result-item":3,"./tracking":6}],5:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var result_page_1 = require("./result-page");
(function () {
    'use strict';
    var settings = {
        target: '.mod-search-result',
        selectors: {
            headline: '.serp-headline',
            facetCustomerType: '.serp-customer-typ',
            facetArea: '.serp-area-facets',
            searchWrapper: '.serp-search',
            searchForm: '.search-form',
            clearFacetInfo: '.serp-clear-filter-info',
            resultWrapper: '.serp-result-wrap',
            noResultInfo: '.serp-no-result-info'
        }
    };
    var encodeHtml = function (input) {
        return input
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };
    var init = function () {
        $(settings.target).each(function (index, item) {
            var searchString = '';
            var searchCustomerContext = '';
            var getParamsString = window.location.search.substring(1);
            var getParams = getParamsString.split('&');
            getParams.forEach(function (indexParam) {
                var indexPair = indexParam.split('=');
                var paramKey = decodeURIComponent(indexPair[0]);
                var paramValue = '';
                try {
                    paramValue = decodeURIComponent(indexPair[1]);
                }
                catch (e) {
                    paramValue = indexPair[1];
                }
                if ('q' === paramKey || 'question' === paramKey) {
                    if (-1 !== paramValue.indexOf('%')) {
                        searchString = window.sessionStorage.getItem('searchTerms');
                    }
                    else {
                        searchString = paramValue.replace(/\+/g, ' ');
                    }
                }
                if ('searchCustomerContext' === paramKey) {
                    searchCustomerContext = paramValue;
                }
            });
            searchString = encodeHtml(searchString);
            $(item).find('.search-string').val(searchString);
            new result_page_1.default($(item), settings.selectors, searchString, searchCustomerContext);
        });
    };
    vf['search-result'] = {
        init: init
    };
}());

},{"./result-page":4}],6:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tracking = /** @class */ (function () {
    function Tracking() {
        if (Tracking._instance) {
            return;
        }
        Tracking._instance = this;
    }
    Tracking.getInstance = function () {
        return Tracking._instance;
    };
    Tracking.prototype.trackPageView = function (searchNumberOfResults, searchTerms, searchType, selectedCustomerContext, selectedAreaFacets) {
        var appliedFilters = [];
        $.each(selectedAreaFacets, function (index, value) {
            appliedFilters.push({
                'facet': 'bereich',
                'value': value
            });
        });
        appliedFilters.push({
            'facet': 'kundenart',
            'value': selectedCustomerContext
        });
        var searchTitle = ($('meta[name="searchTitle"]').attr('content') ? $('meta[name="searchTitle"]').attr('content') : 'Privatkunden');
        var siteStructure = [searchTitle, 'Search'];
        var trackObj = ['pageview', {
                tealiumUseDCF: true,
                'siteStructure': siteStructure,
                'pageType': 'search',
                'searchType': searchType,
                'searchTerms': searchTerms,
                'searchNumberOfResults': searchNumberOfResults,
                'appliedFilters': appliedFilters
            }];
        _ddq.push(trackObj);
    };
    Tracking.prototype.trackFilter = function (selectedCustomerContext, selectedAreaFacets, facet, facetValue, action) {
        var appliedFilters = [];
        $.each(selectedAreaFacets, function (index, value) {
            appliedFilters.push({
                'facet': 'bereich',
                'value': value
            });
        });
        appliedFilters.push({
            'facet': 'kundenart',
            'value': selectedCustomerContext
        });
        _ddq.push(['search filter interaction', {
                action: action + ' filter',
                updatedFilter: {
                    'facet': facet,
                    'value': facetValue
                },
                'appliedFilters': appliedFilters
            }]);
    };
    Tracking._instance = new Tracking();
    return Tracking;
}());
exports.default = Tracking;

},{}]},{},[5]);
